const ADD_ITEM_STAT_KEY_MAP = {
  students: "student_count",
  teachers: "teacher_count",
  visitLogs: "visit_count",
  schedules: "schedule_count",
  finances: "finance_count",
};

const BULK_ADD_STAT_KEY_MAP = {
  students: "student_count",
  teachers: "teacher_count",
};

export const handleAddItemAchievementStats = ({
  incrementStat,
  collectionName,
  data,
  students,
}) => {
  if (!incrementStat) return;

  const targetStatKey = ADD_ITEM_STAT_KEY_MAP[collectionName];

  if (!targetStatKey) {
    console.warn(`[Achievement] 알 수 없는 컬렉션: ${collectionName} - 통계 업데이트 안됨`);
    return;
  }

  console.log(`[Achievement] 통계 증가: 컬렉션=${collectionName} -> 스탯=${targetStatKey}`);
  incrementStat(targetStatKey, 1);

  if (collectionName === "visitLogs" && data.type) {
    incrementStat("visit_type_counts", 1, data.type);

    const student = students.find((s) => s.id === data.studentId);
    if (student && student.birth) {
      const today = new Date();
      const birthStr = typeof student.birth === "string"
        ? student.birth
        : (student.birth?.toDate ? student.birth.toDate().toISOString().split("T")[0] : String(student.birth));
      const birthParts = birthStr.replace(/\./g, "-").split("-");
      if (birthParts.length >= 3) {
        const bMonth = parseInt(birthParts[1]);
        if (today.getMonth() + 1 === bMonth) {
          incrementStat("birthday_visit_count", 1);
        }
      }
    }
  }
};

export const handleBulkAddAchievementStats = ({
  incrementStat,
  checkAndAwardBadges,
  collectionName,
  successCount,
}) => {
  if (!incrementStat || successCount <= 0) return;

  const targetStatKey = BULK_ADD_STAT_KEY_MAP[collectionName];
  if (!targetStatKey) return;

  incrementStat(targetStatKey, successCount);
  checkAndAwardBadges();
};
